import { Injectable } from "@angular/core";
import { MC_APPLICATIONS_ERROR, MCEnvironmentsService, MCStore, MC_UNION_REQUEST_STATUS_CODE } from "@maslul/common-services";
import { Observable } from "rxjs";

export class GeneralStoreData {
    requestStatus: MC_UNION_REQUEST_STATUS_CODE = MC_UNION_REQUEST_STATUS_CODE.DRAFT;
    isSent: boolean = false;
    errorPageCode!: MC_APPLICATIONS_ERROR;
}
const GENERAL: GeneralStoreData =
{
    errorPageCode: MC_APPLICATIONS_ERROR.general,
    requestStatus: MC_UNION_REQUEST_STATUS_CODE.DRAFT,
    isSent: false

}

@Injectable({
    providedIn: 'root',
})
export class GeneralStore extends MCStore<GeneralStoreData> {

    constructor(protected override environmentsService: MCEnvironmentsService) {
        super('', GENERAL, environmentsService);
    }


   

    setRequestStatus(requestStatus: MC_UNION_REQUEST_STATUS_CODE) {
        this.updateState('[General Store Service] set requestStatus', { requestStatus });
        this.updateState('[General Store Service] set isSent', { isSent: requestStatus != MC_UNION_REQUEST_STATUS_CODE.DRAFT });
    }

    getRequestStatus(): Observable<MC_UNION_REQUEST_STATUS_CODE> {
        return this.select(s => s.requestStatus);
    }

    getIsSent(): Observable<boolean> {
        return this.select(s => s.isSent);
    }


    getErrorPageCode(): Observable<MC_APPLICATIONS_ERROR> {
        return this.select(s => s.errorPageCode);
    }

    setErrorPageCode(errorPageCode: MC_APPLICATIONS_ERROR) {
        this.updateState('[General MCStore Service] set errorPageCode', { errorPageCode })
    }
}
